export default __webpack_public_path__ + "static/media/cleanboost_frame.ecc9f037.webp";